module.exports = __webpack_public_path__ + "static/media/lorelai-max.4fd0dcab.wav";